import { uniqBy } from 'lodash-es';
import { makeObservable, observable, runInAction } from 'mobx';

import { RutterConnection } from '~hooks/useRutter/models';

export default class RutterIntegrationStore {
  isDeletingConnection: Map<string, boolean> = new Map<string, boolean>();
  isLoadingConnections: boolean = false;
  isSavingConnection: boolean = false;
  connections?: RutterConnection[];

  constructor() {
    makeObservable(this, {
      isDeletingConnection: observable,
      isLoadingConnections: observable,
      isSavingConnection: observable,
      connections: observable,
    });
  }

  createConnectionStart() {
    runInAction(() => {
      this.isSavingConnection = true;
    });
  }

  createConnectionEnd(connection?: RutterConnection) {
    runInAction(() => {
      this.isSavingConnection = false;

      if (connection) {
        this.connections = uniqBy(
          [...(this.connections ?? []), connection],
          (account) => account.id,
        );
      }
    });
  }

  deleteConnectionStart(connectionId: string) {
    runInAction(() => {
      this.isDeletingConnection.set(connectionId, true);
    });
  }

  deleteConnectionEnd(connectionId: string, deleteSuccess?: boolean) {
    runInAction(() => {
      this.isDeletingConnection.set(connectionId, false);

      if (deleteSuccess) {
        const index = (this.connections ?? []).findIndex((connection) => {
          return connection.id === connectionId;
        });

        if (index > -1) {
          this.connections?.splice(index, 1);
        }
      }
    });
  }

  fetchConnectionsStart() {
    runInAction(() => {
      this.isLoadingConnections = true;
      this.connections = undefined;
    });
  }

  fetchConnectionsEnd(connections?: RutterConnection[]) {
    runInAction(() => {
      this.isLoadingConnections = false;
      this.connections = connections;
    });
  }
}
